// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zy7Q","left":"styles_left__oja4v","desktopActions":"styles_desktopActions__3Jw1J","title":"styles_title__3kEj4"};